module.exports = __webpack_public_path__ + "img/341.04043508.png";